/** API and auth configuration. Values come from .env.local (see .env.example). */

export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL || '';

export const COGNITO_USER_POOL_ID: string =
  import.meta.env.VITE_COGNITO_USER_POOL_ID || '';

export const COGNITO_CLIENT_ID: string =
  import.meta.env.VITE_COGNITO_CLIENT_ID || '';

export const COGNITO_REGION: string =
  import.meta.env.VITE_COGNITO_REGION || 'eu-central-1';

export const WS_ENDPOINT: string =
  import.meta.env.VITE_WS_ENDPOINT || '';

export const COGNITO_DOMAIN: string =
  import.meta.env.VITE_COGNITO_DOMAIN || '';

/** True when a backend is configured (Cognito + API URL are set). */
export const IS_BACKEND_CONFIGURED: boolean =
  COGNITO_USER_POOL_ID !== '' && COGNITO_CLIENT_ID !== '' && API_BASE_URL !== '';

export const STRIPE_PUBLISHABLE_KEY: string =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';

export const STRIPE_HOBBY_MONTHLY_PRICE_ID: string =
  import.meta.env.VITE_STRIPE_HOBBY_MONTHLY_PRICE_ID || '';

export const STRIPE_HOBBY_ANNUAL_PRICE_ID: string =
  import.meta.env.VITE_STRIPE_HOBBY_ANNUAL_PRICE_ID || '';

export const STRIPE_PRO_MONTHLY_PRICE_ID: string =
  import.meta.env.VITE_STRIPE_PRO_MONTHLY_PRICE_ID || '';

export const STRIPE_PRO_ANNUAL_PRICE_ID: string =
  import.meta.env.VITE_STRIPE_PRO_ANNUAL_PRICE_ID || '';

export const STRIPE_TEAM_MONTHLY_PRICE_ID: string =
  import.meta.env.VITE_STRIPE_TEAM_MONTHLY_PRICE_ID || '';

export const STRIPE_TEAM_ANNUAL_PRICE_ID: string =
  import.meta.env.VITE_STRIPE_TEAM_ANNUAL_PRICE_ID || '';

export { getIdToken as getAuthToken } from '@/api/auth';
